module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-13-32-343.6400e1c0.mp4";